var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283 213",
    width: 20,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m222.7 106.7l54.4-72.6c2.3-3.1 3.8-6.9 4.1-10.9 0.4-3.9-0.3-7.9-2.1-11.4-1.8-3.6-4.5-6.5-7.9-8.6-3.4-2.1-7.2-3.2-11.2-3.2h-256c0-5.7-2.2-11.1-6.2-15.1-4-4-9.5-6.2-15.1-6.2-5.7 0-11.1 2.2-15.1 6.2-4 4-6.3 9.4-6.3 15.1v362.7h-21.3c-5.7 0-11.1 2.2-15.1 6.2-4 4-6.2 9.4-6.2 15.1 0 5.7 2.2 11.1 6.2 15.1 4 4 9.4 6.2 15.1 6.2h85.3c5.7 0 11.1-2.2 15.1-6.2 4-4 6.3-9.4 6.3-15.1 0-5.7-2.3-11.1-6.3-15.1-4-4-9.4-6.2-15.1-6.2h-21.3v-149.4h256c4 0 7.8-1.1 11.2-3.2 3.4-2 6.1-5 7.9-8.6 1.8-3.5 2.5-7.5 2.1-11.4-0.3-4-1.8-7.7-4.1-10.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpFlag);
export default __webpack_public_path__ + "static/media/exp_flag.f93f2498d16510ad5acdc4eee4688cbb.svg";
export { ForwardRef as ReactComponent };